export enum FEEDBACK_TYPE_CODE {
  FEEDBACK = 1,
  ERROR = 2,
}

export interface IFeedback {
  feedback_text: string;
  feedback_type: FEEDBACK_TYPE_CODE;
  rating: number;
}
